import React from "react";
import classNames from "classnames";
import getConfig from "next/config";
const {
  publicRuntimeConfig: { settings },
} = getConfig();

const ImageTag = (props) => (
  <img
    src={props.src}
    alt={props.title}
    width={props.width}
    height={props.height}
    className={props.className}
  />
);

const Image = (props) => {
  const imageClassNames = classNames({
    "u-text-align-center": props.alignCenter,
  });

  const imageClass = `${props.classNames || ""} ${imageClassNames}`;

  const imageProps = {
    alt: props.title,
    width: props.width && props.width.length > 0 ? props.width : null,
    height: props.height && props.height.length > 0 ? props.height : null,
    className: props.alignCenter
      ? "u-display-iblock u-text-vertical-middle"
      : "",
  };

  if (
    props.extUrl === "" &&
    props.picked.length > 0 &&
    props.picked[0].path &&
    props.picked[0].name
  ) {
    // TODO: THIS IS NOT RIGHT!
    // Check config out
    // this line --> imageProps.src = `${config.imageServer}${parent.content.picked[0].path}${parent.content.picked[0].name}`;
    // imageProps.src = "https://via.placeholder.com/200x300";

    imageProps.src = `${settings.cdn}${props.picked[0].path}${props.picked[0].name}`;
  } else {
    imageProps.src = props.extUrl;
  }

  return (
    <div className={imageClass}>
      {props.linkUrl && props.linkUrl.length > 0 ? (
        <a href={props.linkUrl} target="_blank" rel="noopener noreferrer">
          <ImageTag {...imageProps} />
        </a>
      ) : (
        <ImageTag {...imageProps} />
      )}
    </div>
  );
};

export default Image;
